import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer'
import { Progress } from 'modules/types'
import { arrToDict, getIds } from 'modules/utils/helpers'
import { LIST_PAGE_SIZE } from 'modules/constants'
import { FetchError } from 'modules/domain/types'
import {
  SeedTrackerState,
  SeedTrackerListRequestFilter,
  SeedTrackerListRequestSorting,
  SeedTracker,
  SeedTrackerListMeta,
} from './types'

const initialState: SeedTrackerState = {
  items: {},
  meta: {},
  ids: [],

  listFetchProgress: Progress.IDLE,
  listFetchError: null,
  listFetchNextProgress: Progress.IDLE,
  listFetchNextError: null,
  itemFetchProgress: Progress.IDLE,
  itemFetchError: null,
  addProgress: Progress.IDLE,
  addError: null,
  updateProgress: Progress.IDLE,
  updateError: null,
  removeProgress: Progress.IDLE,
  removeError: null,

  filter: {},
  sorting: { sort_field: 'variety', sort_reversed: false },
  page: 1,
  total: 0,
  pageSize: LIST_PAGE_SIZE,
  listMeta: undefined,
}

class SeedTrackerReducer extends ImmerReducer<SeedTrackerState> {
  listRequested(params: {
    filter?: SeedTrackerListRequestFilter
    sorting?: SeedTrackerListRequestSorting
    page?: number
  }) {
    this.draftState.listFetchProgress = Progress.WORK
    this.draftState.listFetchError = null
    this.draftState.filter = params.filter || this.draftState.filter
    this.draftState.sorting = params.sorting || this.draftState.sorting
    this.draftState.page = typeof params.page === 'undefined' ? this.draftState.page : params.page
  }

  listRequestSucceed(list: SeedTracker[], total: number, page: number, listMeta?: SeedTrackerListMeta) {
    this.draftState.listFetchProgress = Progress.SUCCESS
    this.draftState.total = total
    this.draftState.page = page
    this.draftState.items = arrToDict(list)
    this.draftState.meta = arrToDict(
      list.map((item) => ({
        id: item.id,
        fetchProgress: Progress.SUCCESS,
        fetchError: null,
        removeProgress: Progress.IDLE,
        removeError: null,
        updateProgress: Progress.IDLE,
        updateError: null,
      })),
    )
    this.draftState.ids = getIds(list)
    this.draftState.listMeta = listMeta
  }

  listRequestFailed(error: FetchError) {
    this.draftState.listFetchProgress = Progress.ERROR
    this.draftState.listFetchError = error
  }

  filterUpdated(filter: SeedTrackerListRequestFilter) {
    this.draftState.filter = filter
    this.draftState.listFetchProgress = Progress.WORK
  }

  sortingUpdated(sorting: SeedTrackerListRequestSorting) {
    this.draftState.sorting = sorting
    this.draftState.listFetchProgress = Progress.WORK
  }
}

export const SeedTrackerActions = createActionCreators(SeedTrackerReducer)
export default SeedTrackerActions
export const reducer = createReducerFunction(SeedTrackerReducer, initialState)
